import Navbar from "./Navbar";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Header = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  // Normalize pathname
  const path = location.pathname.toLowerCase();
    const embed =
    location.pathname.includes("embed") ||
    location.state?.embed === true;

  // Paths where Header (Navbar) should not show
  const hiddenPaths = [
    "/login",
    "/register"
  ];

  // Conditions where we hide Header (embedded booking)
  const isEmbed =
    (path.includes("/personal") && embed) ||
    (path.includes("/booking") && embed) ||
    (path.includes("/checkout") && embed) ||
    (path.includes("/availability") && embed);

  if (hiddenPaths.includes(path) || isEmbed) {
    return <></>; // Hide header
  }

  // Special case for home page
  if (path === "/") {
    return (
      <Navbar
        key={i18n.language} // 👈 force re-render on language change
        borderBottom=""
        marginBottom=""
        background="linear-gradient(to right, #f1f5f9, #eaeff4)"
      />
    );
  }

  // Default Navbar for other pages
  return (
    <Navbar
      key={i18n.language} // 👈 force re-render on language change
      borderBottom="1px solid"
      marginBottom="4px"
    />
  );
};

export default Header;
